import EditProfileForm from './EditProfileForm';

export default EditProfileForm;


// WEBPACK FOOTER //
// ./src/components/forms/EditProfileForm/index.js